import React, { useRef, useState, useEffect } from "react"
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from "react-google-recaptcha-v3"

import { useConfig } from "../../hooks/use-config"
import EvInputUIComp from "./evinput"

const EmailVerifier = (props) => {
  const { executeRecaptcha } = useGoogleReCaptcha()
  const { clearout: clearoutConfig } = useConfig()
  const [isExecuting, setIsExecuting] = useState(false)
  const [canEnableSubmitButton, enableSubmitButton] = useState(false)
  const [evResponse, setEvResponse] = useState(null)
  const emailInputEleRef = useRef()
  const buttonEleRef = useRef()

  const _getEmailInputValue = () => {
    return emailInputEleRef && emailInputEleRef.current
      ? emailInputEleRef.current.value.trim()
      : ""
  }

  const _executeEVForInput = async ({ emailVal }) => {
    try {
      setIsExecuting(true)

      const captchaToken = await executeRecaptcha()
      const bodyPayload = {
        email: emailVal,
        source_agent: "instant_verify",
        timeout: 180000,
        captchaToken,
      }
      fetch(clearoutConfig.api.public_email_verify, {
        // Enter your IP address here
        method: "POST",
        body: JSON.stringify(bodyPayload), // body data type must match "Content-Type" header
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      })
        .then((response) => response.json())
        .then((evResponse) => {
          setEvResponse(evResponse)
          setIsExecuting(false)
          // console.log('evResponse:', evResponse)
        })
        .catch((err) => {
          console.error("Public Email Verify Errored:", err)
          setEvResponse({ status: "failed", error: { message: err.message } })
        }) 
        .finally(() => {
          setIsExecuting(false);
        });
    } catch (e) {
      console.error(e)
    }
  }

  const onEmailInputEleKeyUp = ({ key }) => {
    // check user typed something else disable the submit button
    let emailVal = _getEmailInputValue()
    if (emailVal.length > 0) {
      enableSubmitButton(true)
    } else {
      enableSubmitButton(false)
    }

    // check use pressed enter key if so initiate verification
    if (key === "Enter") {
      emailVal.length > 0 && _executeEVForInput({ emailVal })
    }
  }

  const onButtonEleKeyUp = ({ key }) => {
    // check use pressed enter key if so initiate verification
    if (key === "Enter") {
      let emailVal = _getEmailInputValue()
      emailVal.length > 0 && _executeEVForInput({ emailVal })
    }
  }

  const onButtonEleClick = (e) => {
    let emailVal = _getEmailInputValue()
    emailVal.length > 0 && _executeEVForInput({ emailVal })
  }

  return (
    <>
      <EvInputUIComp
        placeholder={props.placeholder}
        emailInputEleRef={emailInputEleRef}
        buttonEleRef={buttonEleRef}
        onEmailInputEleKeyUp={onEmailInputEleKeyUp}
        onButtonEleKeyUp={onButtonEleKeyUp}
        onButtonEleClick={onButtonEleClick}
        isExecuting={isExecuting}
        enableSubmitButton={canEnableSubmitButton}
        evResponse={evResponse}
      />
    </>
  )
}

// Lazy load email verifier with recaptcha based on the scrollY position
// until then just load the emailverifier with out recaptcha
const LazyEmailVerifier = (props) => {
  let [lazyLoadEvComp, setLazyLoadEvComp] = useState(false)

  if (!lazyLoadEvComp && props.hardLazyLoad) {
    setLazyLoadEvComp(true)
  }

  useEffect(() => {
    const onHandleScroll = () => {
      if (
        !lazyLoadEvComp &&
        props.scrollPosY &&
        window.scrollY > props.scrollPosY
      ) {
        setLazyLoadEvComp(true)
      }
    }

    window.addEventListener("scroll", onHandleScroll)
    return () => {
      window.removeEventListener("scroll", onHandleScroll)
    }
  }, [lazyLoadEvComp, props.scrollPosY])

  return (
    <>
      {!lazyLoadEvComp ? (
        <EmailVerifier placeholder={props.placeholder} />
      ) : (
        <React.Suspense
          fallback={<EmailVerifier placeholder={"lazy-fallback@example.com"} />}
        >
          <GoogleReCaptchaProvider
            reCaptchaKey={props.reCaptchaKey}
            scriptProps={{
              async: true, // optional, default to false,
              defer: true, // optional, default to false
              appendTo: "head", // optional, default to "head", can be "head" or "body",
              nonce: undefined, // optional, default undefined
            }}
          >
            <EmailVerifier placeholder={props.placeholder} />
          </GoogleReCaptchaProvider>
        </React.Suspense>
      )}
    </>
  )
}

export { EmailVerifier, LazyEmailVerifier }
